/* ----- Controller: syncActivityModalController ----- */
(function(){
    // add the controller
    SUGApp.controller('syncActivityModalController', syncActivityModalController);
    syncActivityModalController.$inject = ['$scope','$uibModalInstance','$filter','$q','errorService','globalService','integrationService','sugCacheFactory','SUGUtilities','signup'];
    function syncActivityModalController( $scope, $uibModalInstance, $filter, $q, errorService, globalService, integrationService, sugCacheFactory, SUGUtilities, signup ){

        $scope.isProcessingSaModal = false;
        $scope.loaded = false;
        $scope.su = signup;
        $scope.dateFormat = '';
        $scope.commentlen = 46;
        $scope.colspan = 4;
        $scope.jqActivity = [];
        $scope.jqActivityFiltered = [];

        //form model
        $scope.frm = {
            searchFilter:   ''
        };

        /* View Specific Modal Strings */
        $scope.strings = {
              title:  'Sign Up Sync Activity'
            , errors:   {
                errorsTitle:  ''
              , errorsPleaseCorrect:  'Please correct the following issues:'
            }
            , table: {
                  headerdate:           'Date'
                , headertype:           'Action'
                , headerstatus:         'Status'
                , headerresult:         'Result'
                , noData:               'There is no sync activity for this sign up.'
                , noFilteredData:       'No data matched your search criteria. Please try again.'
            }
            , itemsPerPageInvalid:      'Items per page must be a number greater than 0.'
        };

        /* init error service */
        $scope.samodal_es = errorService.newInstance();
        $scope.samodal_es.init();
        $scope.samodal_es.clearErrors();

        /* uibPopover vars */
        $scope.popover = {
            popTrig: 'mouseenter',
            popPlacement: 'top',
            popDelay: 300,
            appendToBody: false
        };

        /* Pagination */
        $scope.recordCount = 0;
        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            numPerPage: 5
        };


        /**
         * Start page flow
         */
        var init = function(){
            //load date/time settings
            dateTZFormats = sugCacheFactory.get('dateAndTZFormats', {});
            if( Object.keys(dateTZFormats).length ){
                updateDateAndTZSettings( dateTZFormats );
                loadData();
            } else {
                getDateAndTZFormats()
                .then(function(dateAndTZFormats){
                    updateDateAndTZSettings( dateAndTZFormats );
                    loadData();
                }); // END getDateAndTZFormats
            }
        };

        /**
         * Method loads data needed for the page in view
         */
        var loadData = function(){
            SUGUtilities.broadCast('isProcessing', true);

            //load frmObj from cache
            $scope.frm = sugCacheFactory.get('frm',{});

            //default the settings
            prepareUserSettings();

            getNPESyncActivity( $scope.su.listid )
            .then(function(activity){
                // set activity array
                $scope.jqActivity = activity;

                // after data is loaded do some processing
                for(var i=0, len=$scope.jqActivity.length; i<len; i++){
                    //format the date: convert to the right timezone, then convert that string back to a date and apply the user's formatting
                    var parsedDate = SUGUtilities.utcToLocalDate( new Date( $scope.jqActivity[i].jobdateepoch ) );
                    $scope.jqActivity[i].dateformatted = $filter("date")(parsedDate, $scope.dateFormat + ' h:mm a');

                    //format the error
                    if( $scope.jqActivity[i].result.trim().length && $scope.jqActivity[i].result.split(':').length > 1){
                        $scope.jqActivity[i].result = $scope.jqActivity[i].result.split(':')[1];
                    }
                }

                // prep $scope data
                $scope.jqActivityFiltered = angular.copy( $scope.jqActivity );
                $scope.recordCount = $scope.jqActivityFiltered.length;

                filterData();

                $scope.loaded = true;
                SUGUtilities.broadCast('isProcessing', false);

            }); // END getNPESyncActivity
        };

        /**
         * Get the NPE Sign Up sync activity data
         */
        var getNPESyncActivity = function( suid ){
            SUGUtilities.broadCast('isProcessing', true);

            var deferred = $q.defer();

            integrationService.getNPESyncActivity( {listid: suid} )
            .then(function (response) {
                if (SUGUtilities.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    $scope.samodal_es.setError('err_syncactivity', SUGUtilities.getAjaxResponseMessage(response) );
                    SUGUtilities.broadCast('isProcessing', false);
                    deferred.reject();
                } else {
                    // successful - set some vars later use
                    var r = SUGUtilities.lowerCaseKeys(response);
                    deferred.resolve(r.data.data);
                }
            });
            return deferred.promise;
        };

        /**
         * Get the user's preferred Date Format
         */
        var getDateAndTZFormats = function() {
            var deferred = $q.defer();
            var dateAndTZFormats = sugCacheFactory.get('dateAndTZFormats', {});
            if (Object.keys(dateAndTZFormats).length === 0){
                globalService.getDateAndTZFormats()
                    .then(function (response) {
                        var r = SUGUtilities.lowerCaseKeys(response);
                        if (r.data && r.data.data) {
                            dateAndTZFormats = r.data.data;
                            sugCacheFactory.set('dateAndTZFormats', dateAndTZFormats);
                        }
                        deferred.resolve(dateAndTZFormats);
                });
            } else {
                deferred.resolve(dateAndTZFormats);
            }
            return deferred.promise;
        };

        var updateDateAndTZSettings = function( dtz ){
            var arrDF = dtz.dateformats;
            for(var i = 0, len = arrDF.length; i < len; i++){
                var val = arrDF[i];
                if(val.selected){
                    $scope.dateFormat = val.short.replace('mm', 'MM');
                    $scope.strings.dateFormat = val.short;
                    break;
                }
            }
        };


        /**
         * Processing event listener.
         */
        $scope.$on('isProcessing', function (event, processing) {
            $scope.isProcessingSaModal = processing;
            if ($scope.isProcessingSaModal) {
                SUGUtilities.showLoading('processing');
                $scope.frmDisableField = true;
            } else {
                $scope.frmDisableField = false;
            }
        });

        /**
         * Method defaults user saves settings for sorting, filter, etc.
         */
        var prepareUserSettings = function() {
            if( !$scope.frm.hasOwnProperty('searchFilter') ){ $scope.frm.searchFilter = ''; }
            if( !$scope.frm.hasOwnProperty('orderColumn') ){ $scope.frm.orderColumn = 'jobdateepoch'; }
            if( !$scope.frm.hasOwnProperty('direction') ){ $scope.frm.direction = true; }
            if( !$scope.frm.hasOwnProperty('numPerPage') ){ $scope.frm.numPerPage = 5; }
            $scope.arrowDir =  $scope.frm.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
            $scope.pagination.numPerPage = $scope.frm.numPerPage;
        };

        /* Apply Settings/Filter */
        var filterData = function() {
            if ($scope.frm.searchFilter !== '') {
                $scope.jqActivityFiltered = $filter('filter')($scope.jqActivity, searchSyncActivity);
                $scope.jqActivityFiltered = $filter('orderBy')($scope.jqActivityFiltered, $scope.frm.orderColumn, $scope.frm.direction);
            } else {
                $scope.jqActivityFiltered = $filter('orderBy')($scope.jqActivity, $scope.frm.orderColumn, $scope.frm.direction);
            }
            $scope.recordCount = $scope.jqActivityFiltered.length;

            // Apply Pagination
            if ($scope.jqActivityFiltered.length) {
                var begin = ($scope.pagination.currentPage - 1) * parseInt($scope.pagination.numPerPage);
                var end = begin + parseInt($scope.pagination.numPerPage);
                $scope.jqActivityFiltered = $scope.jqActivityFiltered.slice(begin, end);

                // If end up with no results, recursively step back until we get valid paged results
                if (!$scope.jqActivityFiltered.length && $scope.pagination.currentPage > 1) {
                    $scope.pagination.currentPage--;
                    filterData();
                }
            }
        };

        /**
         * Method filters table data based on search value
         */
        var searchSyncActivity = function(objActivity){
            if( !$scope.frm.searchFilter
                || objActivity.listid == $scope.frm.searchFilter
                || objActivity.status.toString().toLowerCase().indexOf( $scope.frm.searchFilter.toString().toLowerCase() ) > -1
                || objActivity.type.toString().toLowerCase().indexOf( $scope.frm.searchFilter.toString().toLowerCase() ) > -1
                || objActivity.dateformatted.toString().toLowerCase().indexOf( $scope.frm.searchFilter.toString().toLowerCase() ) > -1
                ){
                return true;
            } else {
                return false;
            }
        };


        /************************
         MODAL EXPOSED FUNCTIONS
        ************************/
        $scope.dismiss = function () {
            $uibModalInstance.dismiss(false);
        };

        /* Column Direct Sort */
        $scope.setSort = function (columnKey) {
            $scope.frm.orderColumn = columnKey;
            $scope.frm.direction = !$scope.frm.direction;
            $scope.arrowDir = $scope.frm.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
            filterData();
        };



        /************************
         MODAL WATCHERS
        ************************/

        /**
         * WATCHER: Pagination
         */
        $scope.$watch('pagination.currentPage + pagination.numPerPage', function () {
            filterData();
        });

        /**
         * WATCHER: frmObj for sorting, filtering, search, setting changes
         */
        $scope.$watchCollection('frm', function (nVal, oVal) {
            var newVal = angular.copy(nVal);
            var oldVal = angular.copy(oVal);

            // validate number per page (stop processing if empty or invalid since we must have it for proper filter/sort)
            if (!$scope.frm.numPerPage || $scope.frm.numPerPage.toString().trim() === '') {
                return;
            } else if (!(angular.isNumber(~~$scope.frm.numPerPage) && isFinite(~~$scope.frm.numPerPage)) || ~~$scope.frm.numPerPage <= 0) {
                SUGUtilities.showMagnificAlert($scope.strings.itemsPerPageInvalid, 'error', '', 'Sorry!');
                $scope.frm.numPerPage = oldVal.numPerPage;
                return;
            }

            /* Apply Filter - Filter through the data Array, NOT the filtered data */
            $scope.jqActivityFiltered = $filter('orderBy')($scope.jqActivity, $scope.frm.orderColumn, $scope.frm.direction);

            /* Update Settings in Factory */
            sugCacheFactory.set( 'frm', angular.copy($scope.frm) );
            prepareUserSettings();

            /* Apply Search Filter if Present - Filter through the data Array, NOT the filtered data */
            if (newVal.searchFilter != oldVal.searchFilter) {
                $scope.jqActivityFiltered = $filter('filter')($scope.jqActivity, searchSyncActivity);
                $scope.jqActivityFiltered = $filter('orderBy')($scope.jqActivityFiltered, $scope.frm.orderColumn, $scope.frm.direction);
                $scope.recordCount = $scope.jqActivityFiltered.length;
            } else {
                filterData();
            }
        });



        init();
    }

}());